export function searchTypeToEntityType(searchType) {
  return searchType === 'companies' ? 'company' : 'person';
}
